// extracted by mini-css-extract-plugin
export var compactFilters = "_ff-4";
export var detailImage = "_ff-1";
export var dropdownContainer = "_ff-2";
export var imageContainer = "_ff-0";
export var selectedCard = "_ff-3";